import React, { useEffect, useRef, useMemo } from 'react';

const ParticleCursor = () => {
    const maxParticles = 20; // Limit total particles
    const particlesRef = useRef([]);
    const canvasRef = useRef(null);
    const contextRef = useRef(null);

    // Use useMemo to memoize the colors array
    const particleColors = useMemo(() => [
        'rgba(100, 255, 218, ', // teal
        'rgba(255, 107, 107, ', // coral red
        'rgba(74, 158, 255, ',  // light blue
        'rgba(255, 217, 61, '   // yellow
    ], []);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        contextRef.current = ctx;

        const resizeCanvas = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };

        resizeCanvas();
        window.addEventListener('resize', resizeCanvas);

        return () => window.removeEventListener('resize', resizeCanvas);
    }, []);

    useEffect(() => {
        let animationFrame;
        let lastParticleTime = 0; // Add throttle
        const particleDelay = 50; // milliseconds between particles

        const addParticle = (x, y) => {
            if (particlesRef.current.length >= maxParticles) {
                particlesRef.current.shift();
            }
            particlesRef.current.push({
                x,
                y,
                size: Math.random() * 3 + 2,
                life: 1,
                velocity: Math.random() * 2 + 1,
                color: particleColors[Math.floor(Math.random() * particleColors.length)]
            });
        };

        const animate = () => {
            const ctx = contextRef.current;
            ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

            particlesRef.current.forEach((particle, i) => {
                particle.life -= 0.02;
                particle.y += particle.velocity;
                particle.velocity *= 1.02;

                if (particle.life > 0) {
                    ctx.beginPath();
                    ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
                    ctx.fillStyle = `${particle.color}${particle.life})`;
                    ctx.fill();
                } else {
                    particlesRef.current.splice(i, 1);
                }
            });

            animationFrame = requestAnimationFrame(animate);
        };

        const handleMouseMove = (e) => {
            const now = Date.now();
            if (now - lastParticleTime > particleDelay) {
                addParticle(e.clientX, e.clientY);
                lastParticleTime = now;
            }
        };

        animate();
        window.addEventListener('mousemove', handleMouseMove);

        return () => {
            cancelAnimationFrame(animationFrame);
            window.removeEventListener('mousemove', handleMouseMove);
        };
    }, [particleColors]);

    return (
        <canvas
            ref={canvasRef}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                pointerEvents: 'none',
                zIndex: 9999
            }}
        />
    );
};

export default ParticleCursor;
